export default {"src":"/_next/static/media/unmatchedTrans.31175b87.svg","height":103,"width":93,"blurWidth":0,"blurHeight":0};